import Vue from 'vue'
import Tickets from '@pages/shop/Tickets'
import CreateUser from '@pages/auth/CreateUser'
import TripBatchAdd from '@pages/admin/TripBatchAdd'
import DownloadTicket from "@pages/shop/DownloadTicket";

require('./bootstrap')

window.Vue = Vue

Vue.prototype.appSettings = window.app.settings

Vue.component('tickets-page', Tickets)
Vue.component('create-user-page', CreateUser)
Vue.component('trip-batch-add', TripBatchAdd)
Vue.component('download-ticket', DownloadTicket)

const apps = []
const areas = document.body.querySelectorAll('.vue')

if (areas !== null) {
    for(let i = 0; i < areas.length; ++i) {
        apps.push(new Vue({
            el: areas[i],
        }))
    }
}
